module.exports = __webpack_public_path__ + "img/join_1.e758ef9a.png";